import { createSlice } from '@reduxjs/toolkit';

export const nativeAppBack = createSlice({
  name: 'nativeAppBack',
  initialState: {
    data: '',
  },

  reducers: {
    setNativeAppBack: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setNativeAppBack } = nativeAppBack.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getNativeAppBack = (state) => {
  return state.nativeAppBack.data;
};

export default nativeAppBack.reducer;
